<template>
  <el-form
    ref="form"
    :model="party"
    :rules="rules"
    size="small"
    inline
    :disabled="isDisabled.value"
    label-position="top"
    class="form-input-width accident-party-form"
  >
    <el-form-item label="驾驶人姓名" prop="name">
      <el-input v-model="party.name" placeholder="请输入驾驶人姓名" />
    </el-form-item>
    <el-form-item label="驾驶人电话" prop="phone">
      <el-input v-model="party.phone" placeholder="请输入驾驶人电话" />
    </el-form-item>
    <el-form-item label="交通方式" prop="transportation">
      <dict-select
        :key="'transportation'"
        v-model="party.transportation"
        type="transportation"
      />
    </el-form-item>
    <el-form-item label="违法行为" prop="illegalAct">
      <dict-select
        :key="'illegal_act'"
        v-model="party.illegalAct"
        type="illegal_act"
      />
    </el-form-item>
    <el-form-item label="违法条款" prop="illegalTerms">
      <dict-select
        :key="'illegal_terms'"
        v-model="party.illegalTerms"
        type="illegal_terms"
      />
    </el-form-item>
    <el-form-item label="定责建议" prop="dutySuggest">
      <dict-select
        class="dictSelect"
        :key="'duty_suggest'"
        v-model="party.dutySuggest"
        type="duty_suggest"
      />
      <el-popover
        :disabled="!accident.liability"
        :width="300"
        @show="getSimulate"
      >
        <img
          slot="reference"
          :style="{ cursor: accident.liability ? 'pointer' : 'not-allowed' }"
          src="@/assets/images/accident/claim.png"
          class="check-icon"
        />
        <p v-loading="liabilityLoading" class="liability-statement">
          {{ liabilityStatement }}
        </p>
      </el-popover>
    </el-form-item>

    <!-- TODO 接口未完成 -->
    <el-form-item label="人脸信息" prop="facePhoto">
      <!-- <el-input /> -->
      <el-image
        style="width: 100px; height: 100px; margin-bottom:10px"
        :src="party.facePhoto"
      />
      <!-- <el-popover @show="getInfoByFacePhoto">
        <svg-icon
          slot="reference"
          icon-class="search-doc"
          style="flex:none;"
          class="search-icon"
        />
        <div>未查找到相关信息</div>
      </el-popover> -->
    </el-form-item>
    <el-form-item label="身份证号码" prop="idCardNum">
      <el-input
        class="dictSelect"
        v-model="party.idCardNum"
        placeholder="请输入身份证号码"
        @change="getInfoByIdCardNum"
      />
      <el-popover @show="getInfoByIdCardNum">
        <svg-icon
          slot="reference"
          icon-class="search-doc"
          style="flex: none"
          class="search-icon"
        />
        <div>{{ popOverInfo }}</div>
      </el-popover>
    </el-form-item>

    <el-form-item label="驾驶证号码" prop="drivingLicenseNum">
      <el-input
        class="dictSelect"
        v-model="party.drivingLicenseNum"
        placeholder="请输入驾驶证号码"
      />
      <el-popover>
        <svg-icon
          slot="reference"
          icon-class="search-doc"
          style="flex: none"
          class="search-icon"
          @click="getDriverByDrivingLicenseNum"
        />
        <ul class="vehicleInfo">
          <li>
            <span>有效期限:</span>
            {{
              drivingInfo && drivingInfo.endDate
                ? drivingInfo.endDate.substr(0, 10)
                : "-"
            }}
          </li>
          <li>
            <span>准驾车型:</span>
            {{
              drivingInfo && drivingInfo.vehicleType
                ? drivingInfo.vehicleType
                : "-"
            }}
          </li>
          <li>
            <span>车辆状态:</span>
            {{
              drivingInfo && drivingInfo.state
                ? drivingInfo.state === "1"
                  ? "异常"
                  : "正常"
                : "-"
            }}
          </li>
          <li>
            <span>异常原因:</span>
            {{ drivingInfo && drivingInfo.reason ? drivingInfo.reason : "-" }}
          </li>
        </ul>
      </el-popover>
    </el-form-item>

    <el-form-item
      label="车辆号码"
      :prop="
        party.transportation && party.transportation > 16
          ? 'carLicenseNum2'
          : 'carLicenseNum'
      "
    >
      <el-input
        class="dictSelect"
        v-model="party.carLicenseNum"
        placeholder="请输入车牌号"
        @change="getInfoByCarLicenseNum"
      />
      <el-popover width="350">
        <svg-icon
          slot="reference"
          icon-class="search-doc"
          style="flex: none"
          class="search-icon"
          @click="getInfoByCarLicenseNum"
        />
        <ul class="vehicleInfo">
          <li>
            <span>有效期限:</span>
            {{
              vehicleInfo && vehicleInfo.endDate
                ? vehicleInfo.endDate.substr(0, 10)
                : "-"
            }}
          </li>
          <li>
            <span>车辆类型:</span>
            {{
              vehicleInfo && vehicleInfo.vehicleType
                ? vehicleInfo.vehicleType
                : "-"
            }}
          </li>
          <li>
            <span>品牌名称:</span>
            {{
              vehicleInfo && vehicleInfo.carBrand ? vehicleInfo.carBrand : "-"
            }}
          </li>
          <li>
            <span>车辆识别号:</span>
            {{
              vehicleInfo && vehicleInfo.vehicleNumber
                ? vehicleInfo.vehicleNumber
                : "-"
            }}
          </li>
          <li>
            <span>使用性质:</span>
            {{ vehicleInfo && vehicleInfo.usage ? vehicleInfo.usage : "-" }}
          </li>
          <li>
            <span>车辆状态:</span>
            {{
              vehicleInfo && vehicleInfo.vehicleState
                ? vehicleInfo.vehicleState === "1"
                  ? "异常"
                  : "正常"
                : "-"
            }}
          </li>
        </ul>
      </el-popover>
    </el-form-item>

    <el-form-item
      label="号牌种类"
      :prop="party.transportation&&party.transportation>16?'carLicenseType2':'carLicenseType'"
    >
      <dict-select
        :key="'car_license_type'"
        v-model="party.carLicenseType"
        type="car_license_type"
      />
    </el-form-item>
    <el-form-item
      label="车损部位"
      :prop="party.transportation&&party.transportation>16?'crashPosition2':'crashPosition'"
    >
      <dict-select
        :key="'crash_position'"
        v-model="party.crashPosition"
        type="crash_position"
      />
    </el-form-item>
    <el-form-item label="交强险保单号" prop="trafficInsuranceNum">
      <el-input
        class="dictSelect"
        v-model="party.trafficInsuranceNum"
        placeholder="请输入保单号"
      />
      <el-popover placement="bottom-end" width="140">
        <div style="color: #0b2756; font-size: 16px">
          <template v-if="party.claimAmount">
            <div>
              <i class="el-icon-success" style="color: #00bf79" />
              已确认理赔
              <div>理赔金额：{{ party.claimAmount }}元</div>
            </div>
          </template>
          <div v-else>
            <i class="el-icon-error" style="color: #d03430" />
            未确认理赔
          </div>
        </div>
        <img
          slot="reference"
          src="@/assets/images/accident/claim.png"
          class="check-icon"
        />
      </el-popover>
    </el-form-item>
    <el-form-item label="交强险公司" prop="trafficInsuranceId">
      <claimsSelect
        :key="new Date().getTime()"
        v-model="party.trafficInsuranceId"
        :type="'Insurance'"
      />
    </el-form-item>
    <el-form-item label="商业险保单号" prop="policyNumber">
      <el-input
        class="dictSelect"
        v-model="party.policyNumber"
        placeholder="请输入商业保单号"
      />
      <el-popover placement="bottom-end" width="140">
        <div style="color: #0b2756; font-size: 16px">
          <template v-if="party.claimAmount">
            <div>
              <i class="el-icon-success" style="color: #00bf79" />
              已确认理赔
              <div>理赔金额：{{ party.claimAmount }}元</div>
            </div>
          </template>
          <div v-else>
            <i class="el-icon-error" style="color: #d03430" />
            未确认理赔
          </div>
        </div>
        <img
          slot="reference"
          src="@/assets/images/accident/claim.png"
          class="check-icon"
        />
      </el-popover>
    </el-form-item>
    <el-form-item label="商业险公司" prop="bxgs">
      <claimsSelect
        :key="new Date().getTime()"
        v-model="party.bxgs"
        :type="'Insurance'"
      />
    </el-form-item>
    <div ref="insurance" class="insuranceBtn">
      <span class="btn_primary btn1" @click="getInsurance">查询保险信息</span>
      <span
        v-if="!btnDisable && (chooseRB > 0 || choosePA > 0 || companyUrl || trafficUrl)"
        :class="hasExecute ? 'btn_primary btn2 execute' : 'btn_primary btn2'"
        @click="execute"
        >保险报案</span
      >
    </div>
    <div>
      <div class="listing">
        <div>
          <el-form-item label="修车公司">
            <claimsSelect v-model="party.repairCompanyId" :type="'Repair'" />
          </el-form-item>
        </div>
        <!-- <div>
          <el-form-item label="拖车费用总计" prop="trailerFees">
            <el-input v-model="trailerFees" disabled />
          </el-form-item>
          <listing :list-data="trailerList" />
        </div> -->
        <!-- <div>
          <el-form-item label="费用总计" prop="repairs">
            <el-input :value="repairs+trailerList" type="textarea" :rows="1" resize="none" disabled />
          </el-form-item>
        </div> -->
      </div>
    </div>
    <div>
          <el-form-item label="修车费用总计" prop="repairs">
            <el-input v-model="repairs" disabled />
          </el-form-item>
          <listing :list-data="repairList" />
        </div>
    <div class="injured">
      <el-form-item
        class="injuredTab"
        v-if="checkListData.length && checkListData.includes('3')"
        label="是否有伤者"
        prop="hasInjured"
      >
        <el-radio-group v-model="hasInjured">
          <el-radio :label="false"> 否 </el-radio>
          <el-radio :label="true"> 是 </el-radio>
        </el-radio-group>
      </el-form-item>
      <div
        v-if="checkListData.length && checkListData.includes('3') && hasInjured"
      >
        <injuredList
          ref="injuredList"
          class="injuredList"
          :active-injured.sync="activeInjured"
          :injured-list="party.partyDirectIndemnity.accidentWoundedList"
        />
      </div>
    </div>

  </el-form>
</template>

<script>
import { validIdNum, validPhone } from "@/utils/validate";
import DictSelect from "./dict-select.vue";
import injuredList from "./injuredList";
import listing from "./listing";
import claimsSelect from "./claimsSelect";
import {
  getLiabilityStatement,
  getInfoByIdCardNum,
  getInfoByDrivingLicenseNum,
  getInfoByCarLicenseNum,
  driverNum,
  queryInsuranceInfo,
  renBao,
  pingAn,
  insuranceReport
} from "@/api/accident/edit";
export default {
  components: { DictSelect, injuredList, listing, claimsSelect },
  inject: {
    isDisabled: { default: () => ({ value: false }) },
    accident: { default: () => {} },
    checkList: { default: () => [] }
  },
  props: {
    party: {
      type: Object,
      require: true,
      default: () => {}
    }
  },
  data() {
    return {
      trailerFees: "", // 拖车费用
      repairs: "", // 修车费用
      trailerList: [], // 拖车清单
      repairList: [], // 修车清单
      activeInjured: "0",
      hasInjured: true, // 是否有伤者
      istowingCompany: "", // 是否需要拖车
      rules: {
        carLicenseNum: [{ required: true, message: "请输入车牌号码" }],
        name: [{ required: true, message: "请填写驾驶人姓名" }],
        transportation: [{ required: true, message: "请选择交通方式" }],
        carLicenseType: [{ required: true, message: "请选择号牌种类" }],
        crashPosition: [{ required: true, message: "请选择车损部位" }],
        idCardNum: [
          { required: true, message: "请输入身份证号码" },
          {
            validator(rule, value, cb) {
              if (value && !validIdNum(value)) {
                cb(new Error("请输入正确的身份证号码"));
              } else {
                cb();
              }
            }
          }
        ],
        phone: [
          {
            validator(rule, value, cb) {
              if (value && !validPhone(value)) {
                cb(new Error("请输入正确的手机号码"));
              } else {
                cb();
              }
            }
          }
        ]
      },
      liabilityStatement: "",
      liabilityLoading: false,
      popOverInfo: "",
      personState: "",
      vehicleState: "",
      drivingLicenseState: "",
      vehicleInfo: null, // 车牌查询信息
      drivingInfo: null, // 驾驶证查询信息
      insuredList: null, // 保协信息
      evn: "", // 环境
      Vin: "", // 人保车架号
      isInsurance: false, // 是否能保险报案
      chooseRB: 0, // 人保公司
      choosePA: 0, // 平安公司
      paObj: {
        accidentId: "",
        vin: "",
        policyNo: "",
        partyName: "",
        partyPhone: "",
        partyCarLicenseNum: "",
        reportPhone: "",
        accidentTime: "",
        accidentAddress: "",
        remark: "",
        accidentType: "",
        woundedName: null,
        objectName: ""
      }, // 平安公司参数
      btnDisable: false, // 是否可点报警按钮
      hasExecute: false, // 是否已一键报警
      companyReport: false, // 商业险标准报案
      trafficReport: false, // 交强险标准报案
      companyUrl: '', // 商业险报案url
      trafficUrl: '', // 交强险报案url
    };
  },
  computed: {
    checkListData() {
      return this.checkList();
    },
    selecaData() {
      let list =
        this.$store.getters.selecaData.length &&
        this.$store.getters.selecaData.filter(el => {
          const arr =
            el.roles &&
            el.roles.filter(role => {
              return role.roleKey === "Insurance";
            });
          return arr && arr.length;
        });
      return list;
    }
  },
  watch: {
    party: {
      // 监听救援托修车费用
      handler(val) {
        if (val.partyMaintenanceList && val.partyMaintenanceList.length) {
          this.trailerFees =
            val.partyMaintenanceList[0] &&
            val.partyMaintenanceList[0].totalCost;
          this.repairs =
            val.partyMaintenanceList[1] &&
            val.partyMaintenanceList[1].totalCost;
          this.trailerList =
            val.partyMaintenanceList[0] &&
            val.partyMaintenanceList[0].maintenanceListUrl;
          this.repairList =
            val.partyMaintenanceList[1] &&
            val.partyMaintenanceList[1].maintenanceListUrl;
        }
      },
      immediate: true,
      deep: true
    },
    "party.towingCompanyId"(val) {
      if (val) {
        if (!this.party.partyMaintenanceList) {
          this.$set(this.party, "partyMaintenanceList", []);
        }
        if (this.party.partyMaintenanceList.length) {
          let repairList = null;
          let towingList = null;
          this.party.partyMaintenanceList.forEach(el => {
            if (el && el.type === 2) {
              repairList = el;
            }
            if (el && el.type === 1) {
              towingList = el;
            }
          });
          this.party.partyMaintenanceList.splice(
            0,
            this.party.partyMaintenanceList.length
          );
          if (repairList) {
            this.party.partyMaintenanceList.push(repairList);
          }
          if (towingList) {
            towingList.company = val;
            this.party.partyMaintenanceList.push(towingList);
          } else {
            this.party.partyMaintenanceList.push({ type: 1, company: val });
          }
        } else {
          this.party.partyMaintenanceList.push({ type: 1, company: val });
        }
      } else {
        if (this.party.partyMaintenanceList.length) {
          let repairList = null;
          this.party.partyMaintenanceList.forEach(el => {
            if (el && el.type === 2) {
              repairList = el;
            }
          });
          this.party.partyMaintenanceList.splice(
            0,
            this.party.partyMaintenanceList.length
          );
          if (repairList) {
            this.party.partyMaintenanceList.push(repairList);
          }
        }
      }
    },
    "party.repairCompanyId"(val) {
      if (val) {
        if (!this.party.partyMaintenanceList) {
          this.$set(this.party, "partyMaintenanceList", []);
        }
        if (this.party.partyMaintenanceList.length) {
          let repairList = null;
          let towingList = null;
          this.party.partyMaintenanceList.forEach(el => {
            if (el && el.type === 1) {
              towingList = el;
            }
            if (el && el.type === 2) {
              repairList = el;
            }
          });
          this.party.partyMaintenanceList.splice(
            0,
            this.party.partyMaintenanceList.length
          );
          if (towingList) {
            this.party.partyMaintenanceList.push(towingList);
          }
          if (repairList) {
            repairList.company = val;
            this.party.partyMaintenanceList.push(repairList);
          } else {
            this.party.partyMaintenanceList.push({ type: 2, company: val });
          }
        } else {
          this.party.partyMaintenanceList.push({ type: 2, company: val });
        }
      } else {
        if (this.party.partyMaintenanceList.length) {
          let towingList = null;
          this.party.partyMaintenanceList.forEach(el => {
            if (el && el.type === 1) {
              towingList = el;
            }
          });
          this.party.partyMaintenanceList.splice(
            0,
            this.party.partyMaintenanceList.length
          );
          if (towingList) {
            this.party.partyMaintenanceList.push(towingList);
          }
        }
      }
    },
    activeInjured(val) {
      this.$store.commit("app/SET_ACTIVEINJURED", val);
    },
    checkListData(val) {
      if (val.includes("3")) {
        this.hasInjured = true;
      } else {
        this.hasInjured = false;
      }
    },
    hasInjured(val) {
      if (!val) {
        this.$set(this.party.partyDirectIndemnity, "accidentWoundedList", [{}]);
        this.activeInjured = "0";
      }
    },
    // 判断保险公司选项包含
    "party.insuranceCompanyId"(newVal, oldVal) {
      if (newVal && newVal.toString() === "207") {
        this.chooseRB += 1;
      } else if (oldVal && oldVal.toString() === "207") {
        if (this.chooseRB > 0) {
          this.chooseRB -= 1;
        }
      }
      if (newVal && newVal.toString() === "206") {
        this.choosePA += 1;
      } else if (oldVal && oldVal.toString() === "206") {
        if (this.choosePA > 0) {
          this.choosePA -= 1;
        }
      }
      if (newVal && newVal.toString() !== "206" && newVal.toString() !== "207") {
        this.selecaData.forEach(el => {
          if (Number(newVal)===el.userId) {
            this.companyUrl = el.insuranceReportUrl ? el.insuranceReportUrl : ''
          }
        });
        this.companyReport = true
      }else {
        this.companyReport = false
        this.companyUrl = ''
      }
    },
    "party.trafficInsuranceId"(newVal, oldVal) {
      if (newVal && newVal.toString() === "207") {
        this.chooseRB += 1;
      } else if (oldVal && oldVal.toString() === "207") {
        if (this.chooseRB > 0) {
          this.chooseRB -= 1;
        }
      }
      if (newVal && newVal.toString() === "206") {
        this.choosePA += 1;
      } else if (oldVal && oldVal.toString() === "206") {
        if (this.choosePA > 0) {
          this.choosePA -= 1;
        }
      }
      if (newVal && newVal.toString() !== "206" && newVal.toString() !== "207") {
        this.selecaData.forEach(el => {
          console.log(newVal);
          if (Number(newVal)===el.userId) {
            console.log(1233445);
            this.trafficUrl = el.insuranceReportUrl ? el.insuranceReportUrl : ''
          }
        });
        this.trafficReport = true
      }else {
        this.trafficReport = false
        this.trafficUrl = ''
      }
    }
  },
  created() {
    this.evn =
      location.hostname !== "traffic-police-yc.aegis-info.com" ? "test" : "pro";
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    getSimulate() {
      this.liabilityLoading = true;
      getLiabilityStatement(this.accident.id)
        .then(({ data }) => {
          this.liabilityStatement = data;
        })
        .finally(() => {
          this.liabilityLoading = false;
        });
    },
    // 身份证查询信息
    async getInfoByIdCardNum() {
      console.log(123);
      if (this.party.idCardNum) {
        driverNum(this.party.idCardNum).then(res => {
          if (res.code === 0 && res.data > 1) {
            this.$confirm(
              "此当事人一年内发生三次及以上次事故，有骗保嫌疑！",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            );
          }
        });
      }
      if (!this.party.idCardNum) {
        this.popOverInfo = "暂无相关信息！";
        return;
      }
      let dataId = await getInfoByIdCardNum(this.party.idCardNum);
      this.personState = dataId.data.personState || "-";
      this.popOverInfo = `人员状态： ${this.personState}`;
    },
    // 车牌查询信息
    getInfoByCarLicenseNum() {
      console.log(123);
      if (this.party.carLicenseNum) {
        driverNum(null, this.party.carLicenseNum).then(res => {
          if (res.code === 0 && res.data > 1) {
            this.$confirm(
              "此车辆一年内发生三次及以上次事故，有骗保嫌疑！",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              }
            );
          }
        });
        getInfoByCarLicenseNum(this.party.carLicenseNum).then(res => {
          this.vehicleInfo = null;
          if (res.data) {
            this.vehicleInfo = res.data;
            this.Vin = res.data.vehicleNumber
            // if (res.data.vehicleType) {
            //   this.$set(
            //     this.party,
            //     "carLicenseType",
            //     this.vehicleInfo.vehicleType
            //   );
            // }
          }
        });
      }
    },
    // 驾驶证查询信息
    async getDriverByDrivingLicenseNum() {
      if (this.party.drivingLicenseNum) {
        this.drivingInfo = null;
        const info = await getInfoByDrivingLicenseNum(
          this.party.drivingLicenseNum
        );
        this.drivingInfo = info.data;
      }
    },
    // 查询保险信息
    getInsurance() {
      console.log('查询保险信息');
      if(this.vehicleInfo == null){
        this.$message.error('未查询到保险信息！')
        return
      }
      const type = this.party.carLicenseType;
      let carType = "";
      if (type === "其他号牌") {
        carType = "99";
      } else if (this.party.carLicenseType.length === 1) {
        carType = "0" + this.party.carLicenseType;
      } else {
        carType = this.party.carLicenseType;
      }
      console.log(carType, this.vehicleInfo.vehicleNumber);
      queryInsuranceInfo(
        this.party.carLicenseNum,
        carType,
        this.vehicleInfo.vehicleNumber
      ).then(res => {
        if (!res.data.Packet.Body) {
          this.$message.error("未查询到保险信息！");
          return;
        }
        const list = res.data && res.data.Packet.Body.PolicyInfo;
        this.insuredList = list;
        if (list && list.length) {
          list.forEach(el => {
            if (el.CoverageType === 2) {
              const trafficInsuranceCode = el.CompanyCode;
              this.$set(this.party, "trafficInsuranceNum", el.PolicyNo);
              this.selecaData.forEach(val => {
                if (val.insuranceCode === trafficInsuranceCode) {
                  this.$set(this.party, "trafficInsuranceId", val.userId);
                  if (
                    (this.evn !== "pro" && val.userId.toString() === "267") ||
                    (this.evn === "pro" && val.userId.toString() === "207")
                  ) {
                    console.log("交强车架号:" + el.Vin);
                    this.Vin = el.Vin;
                  }
                  if (
                    (this.evn !== "pro" && val.userId.toString() === "265") ||
                    (this.evn === "pro" && val.userId.toString() === "206")
                  ) {
                    this.paObj.vin = el.Vin;
                    this.paObj.policyNo = el.PolicyNo;
                  }
                }
              });
            }
            if (el.CoverageType === 1) {
              const policyCode = el.CompanyCode;
              this.$set(this.party, "policyNumber", el.PolicyNo);
              this.selecaData.forEach(val => {
                if (val.insuranceCode === policyCode) {
                  this.$set(this.party, "insuranceCompanyId", val.userId);
                  if (
                    (this.evn !== "pro" && val.userId.toString() === "267") ||
                    (this.evn === "pro" && val.userId.toString() === "207")
                  ) {
                    console.log("商险车架号:" + el.Vin);
                    this.Vin = el.Vin;
                  }
                  if (
                    (this.evn !== "pro" && val.userId.toString() === "265") ||
                    (this.evn === "pro" && val.userId.toString() === "206")
                  ) {
                    this.paObj.vin = el.Vin;
                    this.paObj.policyNo = el.PolicyNo;
                  }
                }
              });
            }
          });
        }
      });
    },
    // 一键报警
    execute() {
      if (this.hasExecute) {
        return
      }
      console.log(this.chooseRB,this.choosePA);
      let mgs = '';
      if (!this.party.name) {
        mgs += "驾驶人姓名，";
      }
      if (!this.party.phone) {
        mgs += "驾驶人电话，";
      }
      if (!this.accident.accidentTime) {
        mgs += "事故时间，";
      }
      if (
        this.accident.objectDestroyed !== false &&
        this.accident.objectDestroyed !== true
      ) {
        mgs += "是否物损，";
      }
      if (this.accident.objectDestroyed === true && !this.accident.objectName) {
        mgs += "物损名称，";
      }
      if (!this.party.carLicenseNum) {
        mgs += "车牌号码，";
      }
      if (!this.accident.remark) {
        mgs += "备注事故经过，";
      }
      if (mgs) {
        this.$message.error("请先填写" + mgs + "!");
        return;
      }
      let insuredName = ''
      if (this.insuredList && this.insuredList.length) {
        insuredName = this.insuredList[0].InsuredName
      }
      if (this.vehicleInfo) {
        insuredName = this.vehicleInfo.owner
      }
      if (!insuredName) {
        // console.log(this.insuredList[0].InsuredName,this.vehicleInfo.owner);
        this.$message.error('请先查询保险信息或车牌号信息！')
        return
      }
      const paramsOb = {
        accidentId: this.$route.params.id,
        insuredName: (this.insuredList && this.insuredList.length && this.insuredList[0].InsuredName) || (this.vehicleInfo && this.vehicleInfo.owner),
        partyName: this.party.name,
        partyPhone: this.party.phone,
        partyCarLicenseNum: this.party.carLicenseNum,
        reportPhone: this.accident.reportPhone,
        accidentTime: this.accident.accidentTime,
        accidentAddress: this.accident.accidentAddress,
        remark: this.accident.remark,
        accidentType: this.checkListData.length
          ? this.checkListData.join(",")
          : "1",
        objectName: this.accident.objectName
      };
      if (this.chooseRB > 0) {
        if (!this.Vin) {
          this.$message.error("保险公司不正确，请先查询保险信息！");
          return;
        }
        console.log(
          paramsOb.accidentId,
          this.Vin,
          paramsOb.partyName,
          paramsOb.partyPhone,
          paramsOb.partyCarLicenseNum,
          paramsOb.insuredName,
          paramsOb.accidentTime,
          paramsOb.objectName,
          paramsOb.accidentType
        );
        // 人保报案
        if (!this.hasExecute) {
          this.hasExecute = true;
          renBao(
            paramsOb.accidentId,
            this.Vin,
            paramsOb.partyName,
            paramsOb.partyPhone,
            paramsOb.partyCarLicenseNum,
            paramsOb.insuredName,
            paramsOb.accidentTime,
            this.accident.objectName,
            paramsOb.accidentType
          )
            .then(res => {
              this.hasExecute = false;
              this.$message.info(res.msg)
              if (res.code === 0) {
                this.btnDisable = true;
                // this.$message.success(res.msg);
              }
            })
            .catch(err => {
              this.hasExecute = false;
              this.$message.error(res.msg)
            });
        }
      }
      // if (this.choosePA > 0) {
      //   if (!this.paObj.vin || !this.paObj.policyNo) {
      //     this.$message.error('保险公司不正确，请先查询保险信息！');
      //     return;
      //   }
      //   Object.keys(paramsOb).forEach(key => {
      //     this.paObj[key] = paramsOb[key];
      //   });
      //   console.log(this.party.partyDirectIndemnity);
      //   if (this.checkListData.includes('3') && this.party.partyDirectIndemnity.accidentWoundedList.length) {
      //     const nameArr = []
      //     this.party.partyDirectIndemnity.accidentWoundedList.forEach(el => {
      //       if (el && el.name) {
      //         nameArr.push(el.name);
      //       }else {
      //         this.$message.error('请填写伤者信息！')
      //       }
      //     })
      //     this.paObj.woundedName = nameArr.length ? nameArr.join(',') : null
      //   }else {
      //     this.paObj.woundedName = null;
      //   }
      //   console.log('平安报案：'+this.paObj);
      //   // 平安报案
      //   pingAn(this.paObj).then(res => {
      //     if (res.code === 0) {
      //       this.btnDisable = true
      //       this.$message.success('平安一键报案成功！');
      //     }
      //   });
      // }
      if (this.trafficReport) {
        if (!this.trafficUrl) {
          this.$message.error('暂未对接该交强险公司！')
        }else {
          const obj = Object.assign(paramsOb,{vin:this.Vin,url:this.trafficUrl})
          // obj.insuredName = '英才'
          // obj.partyCarLicenseNum = '苏ED37608'
          insuranceReport(obj, {objectName:this.accident.objectName}).then(res=>{
            this.$message.success(res.msg)
          })
        }
      }
      if (this.companyReport) {
        if (!this.companyUrl) {
          this.$message.error('暂未对接该商业险公司！')
        }else {
          const obj = Object.assign(paramsOb,{vin:this.Vin,url:this.companyUrl})
          // obj.insuredName = '英才'
          insuranceReport(obj, {objectName:this.accident.objectName}).then(res=>{
            this.$message.success(res.msg)
          })
        }
      }
    }
  }
};
</script>
<style lang="less">
.accident-party-form {
  padding: 40px 68px 60px;
  .el-form-item__content {
    display: inline-flex;
    align-items: center;

    .check-icon {
      cursor: pointer;
      margin-left: 10px;
      position: relative;
      top: 5px;
      width: 20px;
      height: 20px;
    }
    .search-icon {
      color: #1890ff;
      font-size: 24px;
      margin-left: 8px;
      position: relative;
      top: 4px;
    }
  }
}
.liability-statement {
  width: 100%;
  height: 300px;
  overflow: auto;
}
.heading {
  margin: 0 0 15px 15px;
  font-size: 16px;
  font-weight: 700;
}
.listing {
  width: 300px;
  // margin-top: 60px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.labelSt {
  margin-right: 15px;
  color: #606266;
  font-size: 16px;
  font-weight: 700;
}
.vehicleInfo {
  max-width: 400px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 0px;
  li {
    list-style: none;
    width: 49%;
    color: #0b2756;
    margin-bottom: 10px;
  }
}
.insuranceBtn {
  width: 100%;
  margin-bottom: 50px;
  text-align: center;
  .btn_primary {
    width: 160px;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    border-radius: 4px;
    margin-right: 10px;
    outline: none;
    cursor: pointer;
  }
  .btn1 {
    background: rgba(14, 189, 53, 0.1);
    color: #0ebd35;
    border: 1px solid #0ebd35;
    &:hover {
      background: rgba(14, 189, 53, 0.1);
      color: #0ebd35;
    }
  }
  .btn2 {
    background: rgba(255, 125, 0, 0.1);
    color: #ff7d00;
    border: 1px solid #ff7d00;
    &:hover {
      background: rgba(255, 125, 0, 0.1);
      color: #ff7d00;
    }
  }
}
.execute {
  cursor: not-allowed;
}
.injured {
  .injuredTab {
    margin-top: 50px ;
  }
  .injuredList {
    .el-tabs__header .el-tabs__nav-scroll {
      margin: 0;
    }
    .accident-party-form {
      padding: 0;
    }
  }
}

</style>
